export default __webpack_public_path__ + "static/media/delivery1.cb14d570.JPG";